import { render, staticRenderFns } from "./materiel-add.vue?vue&type=template&id=3bb5f7c3"
import script from "./materiel-add.vue?vue&type=script&lang=js"
export * from "./materiel-add.vue?vue&type=script&lang=js"
import style0 from "./materiel-add.vue?vue&type=style&index=0&id=3bb5f7c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports